import { MouseEventHandler } from "react";
import { v4 as uuidv4 } from "uuid";
import TableCell from "./TableCell";
import Icon from "../Icon";
import Divider from "../Divider/Divider";
import PrimeTooltip from "../PrimeTooltip/PrimeTooltip";
import useTranslations from "../../../core/i18n/useTranslations";

import styles from "./Table.module.css";

export const SubRow = ({
  value,
  icon,
  displayDivider,
  linkTo,
  hierarchyTooltip,
  leftIconTooltip,
  hierarchyButton,
  changeLogButton,
  style = {},
}: {
  value: string | JSX.Element;
  icon?: string;
  displayDivider: boolean;
  linkTo?: string;
  hierarchyTooltip?: boolean;
  leftIconTooltip?: string;
  hierarchyButton?: MouseEventHandler;
  changeLogButton?: MouseEventHandler;
  style?: any;
}) => {
  const t = useTranslations();
  const uniqId = uuidv4();

  return (
    <>
      <span className={`${styles.tableCell} subrow`} style={style}>
        <TableCell
          value={value}
          leftIcon={icon}
          leftIconTooltip={leftIconTooltip}
          iconColor="Grey-300"
          className="cell"
          linkTo={linkTo}
        />
        {hierarchyButton && (
          <>
            <button
              id={`hierarchy-${uniqId}`}
              type="button"
              aria-label="View hierarchy"
              onClick={hierarchyButton}
              className={styles.tableRowActionButton}
            >
              <Icon name="hierarchy" size={24} color="Primary-700" />
            </button>
            {hierarchyTooltip && (
              <PrimeTooltip
                target={`#hierarchy-${uniqId}`}
                content={t("Common:view_hierarchy")}
              />
            )}
          </>
        )}
        {changeLogButton && (
          <>
            <button
              id={`log-${uniqId}`}
              type="button"
              aria-label="View changes"
              onClick={changeLogButton}
              className={styles.tableRowActionButton}
            >
              <Icon name="external-link" size={24} color="Primary-700" />
            </button>
            <PrimeTooltip
              target={`#log-${uniqId}`}
              content={t("Objects:ChangeLogTooltip")}
            />
          </>
        )}
      </span>
      {displayDivider ? <Divider /> : <></>}
    </>
  );
};
